import { urls } from "..";

export function getEventUrl(e) {
    let url = '';
    if(e) {
        if (e.isLive) {
            url =  `${urls.base}/${urls.live.base}/${urls.prematch.event}/${e.id}`;
        } else {
            url =  `${urls.base}/${urls.prematch.base}/${urls.prematch.tournament}/${e.sportRef}_${e.categoryRef}_${e.tournamentRef}/${urls.prematch.event}/${e.id}`;
        }
    }
    
    return url;
}
